import { useEffect, useMemo, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import SwaggerUI from "swagger-ui-react";
import { APIMajorVersions, TabNames } from "../Assets/variables";
import CertificationAlert from "./CertificationAlert";
import { apisv2 } from "../Assets/API/apisv2";
import { apisv1 } from "../Assets/API/apisv1";
import { swaggerUiSpecificationConverter } from "../Utils/contentTransformers";

const APISwagger = () => {
    const {setActiveTabItem, apiInfo } = useOutletContext();
    const versionSelectorElementRef = useRef(APIMajorVersions.v2);
    const [selectedVersion, setSelectedVersion] = useState(apisv2);
    const convertedSpecification = useMemo(
        () => swaggerUiSpecificationConverter(selectedVersion[apiInfo.apiName]),
        [selectedVersion, apiInfo.apiName]
    );

    useEffect(() => {
        setActiveTabItem(TabNames.Swagger);
    }, []);

    function selectMajorVersion() {
        let selectedVersion = versionSelectorElementRef.current.value === APIMajorVersions.v2 ? apisv2 : apisv1;
        setSelectedVersion(selectedVersion);
    }
    
    return (
        <>
            <div id="tab-definition" className="api-panel">
                <div id="swagger-container">
                    <div className="swagger-info">
                        <CertificationAlert />
                        <div className="certification-alert">
                            <i className="certification-alert__icon material-icons material-icons-outlined">help_outline</i>
                            <div className="certification-alert__message">
                                <p><a id="specification-link" href={`/portal/bfi/${String(versionSelectorElementRef.current.value).toUpperCase()}/${apiInfo.apiName}.json`} target="_blank" rel="noopener noreferrer">Open API Specification 3.0.1</a></p>
                            </div>
                        </div>
                        <select name="version" id="selector-version" className="six-dropdown" ref={versionSelectorElementRef} onChange={() => selectMajorVersion()}>
                            { apiInfo.versions.filter((version) => version === APIMajorVersions.v2)[0] && 
                                <option value={APIMajorVersions.v2} defaultValue selected>
                                    {`Version ${APIMajorVersions.v2}`}
                                </option> }
                            { apiInfo.versions.filter((version) => version === APIMajorVersions.v1)[0] && 
                                <option value={APIMajorVersions.v1}>
                                    {`Version ${APIMajorVersions.v1}`}
                                </option> }
                        </select>
                    </div>
                    <div id="ui-wrapper" >
                        <SwaggerUI spec={convertedSpecification} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default APISwagger;